// Řazení a hledání v tabulce vykreslené serverem. Buňky nesou hodnotu pro řazení
// v data-v (číslo nebo text), řádky text pro hledání v data-search.
//   <table x-data="sortTable({ key: 'perf', dir: -1 })"> <th data-key="perf" @click="sort('perf')"> … <td data-k="perf" data-v="12.3">
export function sortTable(initial = {}) {
  return {
    key: initial.key || null,
    dir: initial.dir || -1,
    q: '',
    shown: 0,
    init() {
      if (this.key) this.apply();
      this.shown = this.rows().length;
      this.$watch('q', () => this.filter());
    },
    rows() { return [...this.$root.querySelectorAll('tbody tr')]; },
    value(row) {
      const v = row.querySelector(`[data-k="${this.key}"]`)?.dataset.v ?? '';
      const n = Number(v);
      return v !== '' && !Number.isNaN(n) ? n : v.toLowerCase();
    },
    sort(key) {
      if (this.key === key) {
        this.dir = -this.dir;
      } else {
        // Nový sloupec: text od A, čísla od největšího
        this.key = key;
        const sample = this.rows().map((r) => this.value(r)).find((v) => v !== '');
        this.dir = typeof sample === 'string' ? 1 : -1;
      }
      this.apply();
    },
    apply() {
      const body = this.$root.querySelector('tbody');
      const rows = this.rows().sort((a, b) => {
        const x = this.value(a), y = this.value(b);
        if (x === '' || y === '') return x === '' ? 1 : -1; // prázdné vždy na konec
        return (x > y ? 1 : x < y ? -1 : 0) * this.dir;
      });
      rows.forEach((r) => body.appendChild(r));
    },
    filter() {
      const q = this.q.trim().toLowerCase();
      let n = 0;
      for (const r of this.rows()) {
        const hit = !q || (r.dataset.search || '').includes(q);
        r.hidden = !hit;
        n += hit ? 1 : 0;
      }
      this.shown = n;
    },
    aria(key) { return this.key === key ? (this.dir > 0 ? 'ascending' : 'descending') : 'none'; },
  };
}
